import { PLACES_SERVICE } from "@/services/places.service.js";
import router from '@/router/index';

const state = { listOutput: {}, placeOutput: {}, updateStatusPlace: false};

const actions = {
    getList({ dispatch, commit }, inputGetPlaces) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        PLACES_SERVICE.list(inputGetPlaces.pageNumber, inputGetPlaces.resultsNumber, inputGetPlaces.searchText, inputGetPlaces.status, inputGetPlaces.orderBy)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editPlace({ dispatch, commit }, inputPlace) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        PLACES_SERVICE.edit(inputPlace.id, inputPlace.place, inputPlace.image)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addPlace({ dispatch, commit }, inputPlace) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');
  
        PLACES_SERVICE.add(inputPlace.place, inputPlace.image)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getPlace({ dispatch, commit }, placeId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        PLACES_SERVICE.get(placeId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        PLACES_SERVICE.updateStatus(inputStatus.id, inputStatus.status)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* Add */
    addRequest(state) {
    },
    addSuccess(state) {
        router.push('/locais/lista');
    },
    addFailure(state) {
        //
    },
    /* Edit */
    editRequest(state) {
    },
    editSuccess(state) {
        router.push('/locais/lista');
    },
    editFailure(state) {
        //
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.placeOutput = output;
    },
    getFailure(state) {
        state.placeOutput = {};
    },
    /* Update status */
    updateStatusRequest(state) {
        state.updateStatusPlace = undefined;
    },
    updateStatusSuccess(state) {
        state.updateStatusPlace = true;
    },
    updateStatusFailure(state) {
        state.updateStatusPlace = false;
    },
};

export const places = {
    namespaced: true,
    state,
    actions,
    mutations
};